import React, { useCallback, useEffect, useMemo, useState } from 'react';
import moment from 'moment';
import { observer } from 'mobx-react';
import {
    Block,
    FlexDiv,
    ProgressWithNumber,
    SearchInput,
} from '@awarego-ui/components';
import { SUBJECT_TYPE } from '../../../../utils/constants';
import { formatDate } from '../../../../utils/helpers';
import TableServer from '../../../../components/table/TableServer';
import { useStores } from '../../../../hooks/use-stores';

function TrainingScenarios({ companyId, training }) {
    const { automationStore } = useStores();
    const [query, setQuery] = useState({
        p: 0,
        n: 10,
        order: 'send asc',
        filter: '',
    });

    useEffect(() => {
        automationStore.loadScenarios(companyId, training.id, query);
    }, [automationStore, companyId, training.id, query]);

    const onChangePagingParams = useCallback((p, n) => {
        setQuery((current) =>
            current.p === p && current.n === n ? current : { ...current, p, n }
        );
    }, []);

    const onChangeSort = useCallback((sortBy) => {
        if (!sortBy || sortBy.length === 0) return;
        const order = `${sortBy[0].id} ${sortBy[0].desc ? 'desc' : 'asc'}`;
        setQuery((current) =>
            current.order === order ? current : { ...current, order }
        );
    }, []);

    const columns = useMemo(
        () => [
            {
                Header: 'Delivery date',
                accessor: 'send',
                Cell: (x) => <span>{formatDate(x.value)}</span>,
            },
            {
                Header: 'Scenario',
                accessor: 'name',
                Cell: (x) => <div className="row-title">{x.value}</div>,
            },
            {
                Header: 'Completion rate',
                accessor: 'score',
                Cell: (x) =>
                    x.row.original.type === SUBJECT_TYPE.SCORM_QUIZ ? (
                        <ProgressWithNumber
                            value={
                                x.row.original.questions_count
                                    ? Math.round(
                                          (100 * x.row.original.correctsStats) /
                                              (x.row.original.questions_count *
                                                  training.totalUsers)
                                      )
                                    : 0
                            }
                            width={150}
                            height={6}
                        />
                    ) : (
                        <ProgressWithNumber
                            value={
                                x.row.original.total
                                    ? Math.round(
                                          (100 * x.value) / x.row.original.total
                                      )
                                    : 0
                            }
                            width={150}
                            height={6}
                        />
                    ),
            },
            {
                Header: 'Sent',
                accessor: 'status',
                Cell: (x) =>
                    x.value === 2 ? moment(x.row.original.send).format('ll') : '-',
            },
        ],
        [training.totalUsers]
    );

    return (
        <Block gap={24} tablePadding noBorder resetMargin>
            <FlexDiv flexGrow={1} justifyEnd my={10}>
                <SearchInput
                    label=""
                    placeholder="Search"
                    searchValue={query.filter}
                    onChange={(e) => {
                        const filter = e.target.value || '';
                        setQuery((current) =>
                            current.filter === filter && current.p === 0
                                ? current
                                : { ...current, p: 0, filter }
                        );
                    }}
                    onClear={() =>
                        setQuery((current) =>
                            current.filter === '' && current.p === 0
                                ? current
                                : { ...current, p: 0, filter: '' }
                        )
                    }
                />
            </FlexDiv>
            <TableServer
                columns={columns}
                data={automationStore.scenarios}
                rowsTotal={automationStore.scenariosTotal}
                pagesTotal={Math.ceil(automationStore.scenariosTotal / query.n)}
                initialPageSize={query.n}
                defaultSortBy="send"
                defaultSortDescent={false}
                hidePagination={automationStore.scenariosTotal <= query.n}
                onChangePagingParams={onChangePagingParams}
                onChangeSort={onChangeSort}
                loadingData={automationStore.loadingScenarios}
                manualInitialPageTrigger={query.filter}
            />
        </Block>
    );
}

export default observer(TrainingScenarios);
